var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('core-filter-config',{attrs:{"state":_vm.is,"selfOnly":true},on:{"expand":_vm.onExpandClick,"close":_vm.onCloseClick,"save":_vm.onSaveClick}},[_c('app-config-template-other-currency')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }